import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import styled from "styled-components";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const FootericonsContainer = styled((props: any) => <StyledGrid {...props} />)`
  ${({ theme }) => `
  .icon_container {
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: fit-content;
  }

  .font_size_icon {
    min-width: 38.63px;
    min-height: 38.63px;
    color: gray;
  }
`}
`;

export const FooterIcons = () => {
  return (
    <FootericonsContainer>
      <StyledGrid container xs={9} sm={9} lg={9} gap="10px">
        <StyledGrid item xs={3} sm={3} lg={3} className="icon_container">
          <a href="https://www.facebook.com/Onboard.mex">
            <img
              src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/OnboardStorefrontAssetStore/images-site/icons/icono-facebook.svg"
              alt="facebook-icon"
            />
          </a>
        </StyledGrid>
        <StyledGrid item xs={3} sm={3} lg={3} className="icon_container">
          <a href="https://www.instagram.com/onboardmx/">
            <img
              src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/OnboardStorefrontAssetStore/images-site/icons/icono-instagram.svg"
              alt="instagram-icon"
            />
          </a>
        </StyledGrid>
        <StyledGrid item xs={3} sm={3} lg={3} className="icon_container">
          <a href="https://www.tiktok.com/@onboard.mx">
            <img
              src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/OnboardStorefrontAssetStore/images-site/icons/icono-tiktok.svg"
              alt="tiktok-icon"
            />
          </a>
        </StyledGrid>
      </StyledGrid>
    </FootericonsContainer>
  );
};
